import { render, staticRenderFns } from "./flexSpan.vue?vue&type=template&id=2bbea0c9&"
import script from "./flexSpan.vue?vue&type=script&lang=js&"
export * from "./flexSpan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports